import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import Moment from 'react-moment';

import { deepEqual } from '../utils';
import { calculateAccWorkedMs, calculateWorkedDays, calculateAccWorkedDays } from './helpers';
import snackbar from '../snackbar';

import * as lifeEventTypes from './lifeEvents.types';
import lifeEventsHistory from './lifeEventsHistory.popup';
import driverLifeEventsPopup from './DriverLifeEventsPopup';
import driverFormPopup from './DriverFormPopup';
import SelectionToggle from '../Shared/UI/SelectionToggle/';
import Duration from './../Shared/DateTime/Duration';
import ApiDrivers from '../Api/Drivers';

class DriverRow extends Component {
  constructor(props) {
    super(props);

    this.showLifeEventsHistoryPopup = this.showLifeEventsHistoryPopup.bind(this);
    this.showLifeEventsManagementPopup = this.showLifeEventsManagementPopup.bind(this);
    this.onToggleSelection = this.onToggleSelection.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  onToggleSelection() {
    const { driver: { $key: key } } = this.props;
    this.props.onToggleSelection(key);
  }

  showLifeEventsHistoryPopup() {
    const { driver } = this.props;
    lifeEventsHistory(driver);
  }

  showLifeEventsManagementPopup() {
    const { driver } = this.props;
    driverLifeEventsPopup(driver);
  }

  edit = () => {
    const { driver } = this.props;
    driverFormPopup(driver);
  }

  deactivate = async () => {
    const { driver } = this.props;
    const { status } = await ApiDrivers.deactivate(driver.id);
    if (status === ApiDrivers.Status.DEACTIVATED) {
      snackbar.show({ text: `${driver.firstName} desativado com sucesso!` });
    }
  }

  render() {
    const { driver, isSelected } = this.props;

    const currentLifeEvent = (driver.currentLifeEvent) ? driver.currentLifeEvent : {};
    const futureLifeEvents = (driver.futureLifeEvents) ? driver.futureLifeEvents : {};
    const futureLifeEventsKeys = Object.keys(futureLifeEvents);
    const futureLifeEvent = futureLifeEventsKeys.length > 0
      ? {
        ...futureLifeEvents[futureLifeEventsKeys[0]],
        startedAt: Number(futureLifeEventsKeys[0]),
      } : {};

    const currentLifeEventEndPrediction =
      (currentLifeEvent.eventType === lifeEventTypes.types.WEEKLY_REST)
        ? (
          currentLifeEvent.startedAt + (
            (currentLifeEvent.eventMetaHoursSize || 0) * 60 * 60 * 1000
          )
        ) : 0;

    const accWorkedMs = calculateAccWorkedMs(driver);
    const accWorkedDays = calculateAccWorkedDays(driver);

    const hasHighContinuousWorkedDays = currentLifeEvent.startedAt
      && currentLifeEvent.eventType === lifeEventTypes.types.WORK
      && calculateWorkedDays(driver) >= 18;

    return (
      <tr className={hasHighContinuousWorkedDays ? 'bg-alert' : undefined}>
        <td className="min-width">
          <SelectionToggle
            isSelected={isSelected}
            onToggleSelection={this.onToggleSelection}
          />
        </td>

        <td className="min-width">
          <div
            className="avatar"
            style={{ backgroundImage: `url(${driver.facePicture || '/img/profile-placeholder.png'})` }}
            onClick={this.showLifeEventsManagementPopup}
            onKeyPress={this.showLifeEventsManagementPopup}
            role="button"
            tabIndex={0}
          />

          <div className="title-wrapper">
            <div className="title">
              {driver.firstName}
              {driver.nickname && `, ${driver.nickname}`}
            </div>
            <div className="subtitle">
              {driver.surname}
            </div>
          </div>
        </td>

        <td className="new-lines">{driver.homeAddress}</td>

        {/* DIAS TRABALHADOS */}
        <td>
          {accWorkedDays >= 12 ? (
            <div className={`label-box ${accWorkedDays >= 18 ? 'danger' : 'warning'}`}>
              <Duration ms={accWorkedMs} as="onlyDays" />
            </div>
          ) : (
            <Duration ms={accWorkedMs} as="onlyDays" />
          )}
        </td>

        {/* EVENTO ATUAL */}
        {currentLifeEvent.eventType ? (
          <td>
            <div className="title-wrapper">
              <div className="title">
                {lifeEventTypes.humanizedNames[currentLifeEvent.eventType]}
                {currentLifeEvent.eventType === lifeEventTypes.types.WEEKLY_REST
                  && (currentLifeEvent.eventMetaHoursSize
                    ? `(${currentLifeEvent.eventMetaHoursSize} Horas)`
                    : '(Saldo)'
                  )
                }
              </div>
              <div className="subtitle">
                {'Desde '}
                <strong>
                  <Moment calendar>{currentLifeEvent.startedAt}</Moment>
                </strong>
              </div>
            </div>
          </td>
        ) : (
          <td />
        )}

        {/* PRÓXIMO EVENTO */}
        {futureLifeEvent.startedAt ? (
          <td>
            <div className="title-wrapper">
              <div className="title">
                {lifeEventTypes.humanizedNames[futureLifeEvent.eventType]}
              </div>
              <div className="subtitle">
                {'Começa em '}
                <strong>
                  <Moment calendar>{futureLifeEvent.startedAt}</Moment>
                </strong>
              </div>
            </div>
          </td>
        ) : (
          <td>
            {currentLifeEventEndPrediction > 0 && (
              <div className="title-wrapper">
                <div className="title">
                  {'Previsão de Retorno:'}
                </div>
                <div className="subtitle">
                  <strong style={{ color: (moment().isAfter(currentLifeEventEndPrediction) ? '#B71C1C' : 'inherit') }}>
                    <Moment calendar>{currentLifeEventEndPrediction}</Moment>
                  </strong>
                </div>
              </div>
            )}
          </td>
        )}

        <td className="min-width">
          <a
            role="button"
            tabIndex="0"
            onClick={this.showLifeEventsManagementPopup}
            onKeyPress={this.showLifeEventsManagementPopup}
          >
            Eventos
          </a>
        </td>

        <td className="actions min-width">
          <div className="button-dropdown">
            <i className="md-icon">more_horiz</i>

            <ul>
              <li>
                <a
                  role="button"
                  tabIndex="0"
                  onClick={this.edit}
                  onKeyPress={this.edit}
                >
                  Editar
                </a>
                <a
                  role="button"
                  tabIndex="0"
                  onClick={this.deactivate}
                  onKeyPress={this.deactivate}
                  style={{ color: 'EE5342' }}
                >
                  Desativar
                </a>
              </li>
            </ul>
          </div>
        </td>
      </tr>
    );
  }
}

DriverRow.propTypes = {
  driver: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggleSelection: PropTypes.func.isRequired,
};

export default DriverRow;



// WEBPACK FOOTER //
// ./src/Driver/DriverRow.js